/* eslint-disable */
import {useFormResultStore} from '../../stores/form_result';
const EmptyAnswer = { data: { value: null } }
export {EmptyAnswer}

export default {
  inject: ['formResult'],
  props: {
    index: {},
    cst: {},
    field: {},

    // less warnings
    display_type: {},
  },
  data: ()=>({
    answer: EmptyAnswer,
    formResultStore: {},
  }),
  computed: {
    form_result(){ return this.formResult },
    allAnswers(){ return this.formResultStore.answersByField(this.field.id) },
    storeAnswer(){
      return this.allAnswers[0] || EmptyAnswer
    },
  },
  created () {
    try {
      this.setupFormResultStorage()
    } catch (error) {
      console.error(error);
    }

    this.setupFormResultStorage()
    if (this.$options.skipDisplayCreate) return
    this.setBasicAnswer()
  },
  methods: {
    setBasicAnswer(){
      if (this.$options.skipBasic) return
      this.answer = this.basicAnswerInit(this.field, 0)
      this.setDefaults && this.setDefaults()
    },
    basicAnswerInit(field, not_used_option_index) {
      // try to get a previous answer to this question in this form
      let answer = this.formResultStore.answersByFieldAndOption(field.id, not_used_option_index)[0]
      if ( !answer ) { // otherwise, initialize our own
        answer = this.initializeAnswer(field, {
          option_id: 0
        });
        this.formResultStore.addAnswer(answer)
      }
      return answer;
    },
    initializeAnswer(field, defaults, options = {}) {
      const form_result = this.form_result || options.form_result
      // merge the defaults with the defaults
      let data = {field_label: field.datahash.label}
      if (defaults) {
        data = {...data, ...defaults.data}
        delete defaults.data
      }
      const answer = {
        form_result_id: form_result.id,
        form_id: form_result.form_id,
        field_id: field.id,
        type: field.type + "Answer",
        data: data,
        ...defaults,
      }

      return answer;
    },
    checkboxAnswerInit(field, option_id, form_result) {
      const local_form_result = this.form_result || form_result
      let answer = this.formResultStore.answersByFieldAndOption(field.id, option_id)[0];
      if(!answer) {
        // find the answer defaults in the field
        let value = field.datahash.options.values.find(v=>v.option_id === option_id);
        let isChecked = value.checked === true ; // can be 'No' ;(

        answer = this.initializeAnswer(field, {
          checked: !local_form_result.id ? isChecked : false,
          option_id: option_id,
          data: {
            placeholder_label: value.text_placeholder,
            field_option_label: value.label
          }
        }, {form_result});

        this.formResultStore.addAnswer(answer);
      }
      return answer;
    },
    setupFormResultStorage() {
      this.formResultStore = useFormResultStore(this.formResult)
    },
  },
}